import React from 'react';
import { CheckIcon, GlobeIcon } from 'lucide-react';
import { offerRows } from '../data/content';
import { CTAButton } from './CTAButton';
import { Countdown } from './Countdown';
import { ScarcityBar } from './ScarcityBar';
const includes = ['Un único pago, sin suscripciones ni mensualidades', 'Acceso de por vida a todo el material', 'Todas las futuras actualizaciones incluidas'];
export function Offer() {
  return <section id="oferta" className="w-full bg-cream px-4 py-12 sm:px-6 sm:py-16" data-id="element-165" data-mp="tzmqhs73wt9r">
      <div className="mx-auto max-w-2xl" data-id="element-166" data-mp="p11xacq9v9ut">
        <p className="text-center text-[12px] font-extrabold uppercase tracking-[0.18em] text-brand" data-id="element-167" data-mp="13x14zm9gz7zf">
          🏆 Oferta especial de lanzamiento
        </p>
        <h2 className="mt-3 text-center font-serif text-[28px] font-bold leading-tight text-navy-900 sm:text-4xl" data-id="element-168" data-mp="ywd4m9zcpesj">
          Hoy no estás comprando un PDF
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy-700/80" data-id="element-169" data-mp="2adwe2k3iydzj">
          Estás incorporando una Ruta Clínica que organizará cada decisión
          relacionada con el uso de GLP-1 en tu práctica médica.
        </p>

        <div className="mt-8 overflow-hidden rounded-2xl border border-navy-100 bg-white shadow-card" data-id="element-170" data-mp="ulemxijwngf2">
          <div className="flex items-center justify-between bg-navy-900 px-4 py-3" data-id="element-171" data-mp="zgk8uhdb4v35">
            <span className="text-[11.5px] font-extrabold uppercase tracking-widest text-white" data-id="element-172" data-mp="13j71gkhsyk1e">
              Contenido
            </span>
            <span className="text-[11.5px] font-extrabold uppercase tracking-widest text-navy-200" data-id="element-173" data-mp="bskg5bwfqulx">
              Valor
            </span>
          </div>
          <ul data-id="element-174" data-mp="ft4gspg7wgct">
            {offerRows.map(row => <li key={row.label} className="flex items-start justify-between gap-3 border-b border-navy-100 px-4 py-3 last:border-0" data-id="element-175" data-mp="kle19pykco7p">
                <span className="text-[14px] font-medium leading-snug text-navy-900" data-id="element-176" data-mp="3o9z9xd77qmdp">
                  {row.label}
                </span>
                <span className="shrink-0 text-[14px] font-bold tabular-nums text-navy-700" data-id="element-177" data-mp="vefsi01qy101">
                  {row.value}
                </span>
              </li>)}
          </ul>
          <div className="flex items-center justify-between bg-navy-50 px-4 py-3" data-id="element-178" data-mp="154in24oinn0h">
            <span className="text-[13px] font-extrabold uppercase tracking-wide text-navy-900" data-id="element-179" data-mp="10678xhr6uqcg">
              Valor total
            </span>
            <span className="text-[16px] font-extrabold text-navy-900 line-through" data-id="element-180" data-mp="ch4u0hnxvbln">
              USD $472
            </span>
          </div>
        </div>

        <div className="mt-6 rounded-2xl border-2 border-brand bg-white p-6 text-center shadow-lift" data-id="element-181" data-mp="lht97fp2ji04">
          <p className="text-[13.5px] font-semibold leading-snug text-navy-700" data-id="element-182" data-mp="hfpu8h36xva3">
            Pero como esta es la etapa de lanzamiento, hoy puedes obtener acceso
            completo por solo
          </p>
          <p className="mt-3 font-serif text-6xl font-extrabold leading-none text-brand sm:text-7xl" data-id="element-183" data-mp="1su358lcuig8p">
            $15
          </p>
          <p className="mt-2 text-[13px] font-extrabold uppercase tracking-[0.18em] text-navy-900" data-id="element-184" data-mp="20dcemelcqexr">
            USD · Pago único
          </p>

          <ul className="mx-auto mt-5 max-w-sm space-y-2 text-left" data-id="element-185" data-mp="1qgzm3k1jm74l">
            {includes.map(item => <li key={item} className="flex gap-2" data-id="element-186" data-mp="1verd8bud5p7q">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-187" data-mp="1vhncq4lv0lya" />
                <span className="text-[14px] font-medium leading-snug text-navy-900" data-id="element-188" data-mp="2o4hugtral782">
                  {item}
                </span>
              </li>)}
          </ul>

          <p className="mx-auto mt-5 flex max-w-sm items-start gap-2 rounded-xl bg-brand-light px-4 py-3 text-left text-[13px] font-semibold leading-snug text-navy-900" data-id="element-189" data-mp="2ee5bv731fo4k">
            <GlobeIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-190" data-mp="321wpqf48897y" />
            El cambio de moneda es automático: pagas en la moneda de tu país al
            tipo de cambio del momento, sin trámites extra.
          </p>

          <div className="mt-6" data-id="element-191" data-mp="1e60859dhvv2d">
            <CTAButton label="Quiero la Ruta Clínica GLP-1" size="lg" pulse note="Descarga inmediata • Acceso vitalicio • Garantía de 7 días" data-id="element-192" data-mp="1988cc49qbosw" />
          </div>

          <div className="mt-5 space-y-4" data-id="element-193" data-mp="21x5orqr9erdq">
            <Countdown data-id="element-194" data-mp="21yyt2zeegzik" />
            <ScarcityBar data-id="element-195" data-mp="1wxt3hag1dsd9" />
          </div>
        </div>
      </div>
    </section>;
}